import { GridLocation } from "src/grid/GridLocation";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class JumpInstruction extends Instruction<"jump"> {
  readonly type = "jump";

  act(context: ProgramModel) {
    context.cursorIndex += context.mana;
    context.mana = 0;
  }
}
